import * as Yup from "yup";
import postDocFormModel from "./postDocFormModel";
// import moment from "moment";

const {
  formField: {
    photo,
    //page1
    email,
    password,
    titleNameEng,
    firstNameEng,
    middleNameEng,
    lastNameEng,
    titleNameThai,
    firstNameThai,
    middleNameThai,
    lastNameThai,
    gender,
    dateOfBirth,
    maritalStatus,
    bloodType,
    idCard,
    nationality,

    //page2
    yearOfTheContract,
    faculty,
    department,
    mobileThai,
    mobileCountry,
    studentId,
    mentor_id,
    mentorName,
    mentorEmail,
    startFellowship,
    contractEnd,
    fieldResearch,
    addressInThailand,
    addressInTheCountryOfResidence,

    //page3
    nameOfTheBachelorDegree,
    graduatedUniversityInstituteBachelorDegree,
    countryBachelorDegree,
    dateOfBachelorDegreeGraduation,
    nameOfMasterDegree,
    graduatedUniversityInstituteMasterDegree,
    countryMasterDegree,
    dateOfMasterDegreeGraduation,
    doctoralDegreeBackground,
    graduatedUniversityInstituteDoctoral,
    countryDoctoral,
    dateGraduationDoctoral,

    // Page 4
    workingExperienceList,
    publication,
    awards,
    cvOrResume
  }
} = postDocFormModel;

// const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // page1
  Yup.object().shape({
    [photo.name]: Yup.object()
      .shape({
        [photo.file]: Yup.mixed()
      })
      .nullable(),
    // [email.name]: Yup.string()
    //   .trim()
    //   .email()
    //   .required(`${email.requiredErrorMsg}`),
    // [password.name]: Yup.string()
    //   .trim()
    //   .min(8, "Password is too short - should be 8 chars minimum.")
    //   .matches(/[a-zA-Z]/, "Password can only contain Latin letters.")
    //   .required(`${password.requiredErrorMsg}`),
    [titleNameEng.name]: Yup.string()
      .trim()
      .required(`${titleNameEng.requiredErrorMsg}`),
    [firstNameEng.name]: Yup.string()
      .trim()
      .required(`${firstNameEng.requiredErrorMsg}`),
    [middleNameEng.name]: Yup.string(),
    [lastNameEng.name]: Yup.string()
      .trim()
      .required(`${lastNameEng.requiredErrorMsg}`),
    [titleNameThai.name]: Yup.string()
      .trim()
      .required(`${titleNameThai.requiredErrorMsg}`),
    [firstNameThai.name]: Yup.string()
      .trim()
      .required(`${firstNameThai.requiredErrorMsg}`),
    [middleNameThai.name]: Yup.string(),
    [lastNameThai.name]: Yup.string()
      .trim()
      .required(`${lastNameThai.requiredErrorMsg}`),
    [idCard.name]: Yup.string().trim().required(`${idCard.requiredErrorMsg}`),
    [lastNameEng.name]: Yup.string()
      .trim()
      .required(`${lastNameEng.requiredErrorMsg}`),
    [gender.name]: Yup.string().trim().required(`${gender.requiredErrorMsg}`),
    [dateOfBirth.name]: Yup.date()
      .nullable()
      .required(`${dateOfBirth.requiredErrorMsg}`)
      .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
    [maritalStatus.name]: Yup.string()
      .trim()
      .required(`${maritalStatus.requiredErrorMsg}`),
    [bloodType.name]: Yup.string()
      .trim()
      .required(`${bloodType.requiredErrorMsg}`),
    [nationality.name]: Yup.string()
      .trim()
      .required(`${nationality.requiredErrorMsg}`),
    [yearOfTheContract.name]: Yup.string()
      .trim()
      .required(`${yearOfTheContract.requiredErrorMsg}`)
  }),

  //page2
  Yup.object().shape({
    [faculty.name]: Yup.string().trim().required(`${faculty.requiredErrorMsg}`),
    [department.name]: Yup.string()
      .trim()
      .required(`${department.requiredErrorMsg}`),
    [mobileThai.name]: Yup.string()
      .trim()
      .required(`${mobileThai.requiredErrorMsg}`),
    [mobileCountry.name]: Yup.string()
      .trim()
      .required(`${mobileCountry.requiredErrorMsg}`),
    [studentId.name]: Yup.string()
      .trim()
      .required(`${studentId.requiredErrorMsg}`),
    [mentor_id.name]: Yup.number(),
    [mentorName.name]: Yup.string()
      .trim()
      .required(`${mentorName.requiredErrorMsg}`),
    [mentorEmail.name]: Yup.string().required(
      `${mentorEmail.requiredErrorMsg}`
    ),
    [startFellowship.name]: Yup.date()
      .nullable()
      .required(`${startFellowship.requiredErrorMsg}`)
      .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
    [contractEnd.name]: Yup.date()
      .nullable()
      .required(`${contractEnd.requiredErrorMsg}`)
      .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
    [fieldResearch.name]: Yup.string()
      .trim()
      .required(`${fieldResearch.requiredErrorMsg}`),
    [addressInThailand.name]: Yup.string()
      .trim()
      .required(`${addressInThailand.requiredErrorMsg}`),
    [addressInTheCountryOfResidence.name]: Yup.string()
      .trim()
      .required(`${addressInTheCountryOfResidence.requiredErrorMsg}`)
  }),

  //page3
  Yup.object().shape({
    [nameOfTheBachelorDegree.name]: Yup.string()
      .trim()
      .required(`${nameOfTheBachelorDegree.requiredErrorMsg}`),
    [graduatedUniversityInstituteBachelorDegree.name]: Yup.string()
      .trim()
      .required(
        `${graduatedUniversityInstituteBachelorDegree.requiredErrorMsg}`
      ),
    [countryBachelorDegree.name]: Yup.string()
      .trim()
      .required(`${countryBachelorDegree.requiredErrorMsg}`),
    [dateOfBachelorDegreeGraduation.name]: Yup.date()
      .nullable()
      .required(`${dateOfBachelorDegreeGraduation.requiredErrorMsg}`)
      .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),

    [nameOfMasterDegree.name]: Yup.string()
      .trim()
      .required(`${nameOfMasterDegree.requiredErrorMsg}`),
    [graduatedUniversityInstituteMasterDegree.name]: Yup.string()
      .trim()
      .required(`${graduatedUniversityInstituteMasterDegree.requiredErrorMsg}`),
    [countryMasterDegree.name]: Yup.string()
      .trim()
      .required(`${countryMasterDegree.requiredErrorMsg}`),
    [dateOfMasterDegreeGraduation.name]: Yup.date()
      .nullable()
      .required(`${dateOfMasterDegreeGraduation.requiredErrorMsg}`)
      .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),

    [doctoralDegreeBackground.name]: Yup.string()
      .trim()
      .required(`${doctoralDegreeBackground.requiredErrorMsg}`),
    [graduatedUniversityInstituteDoctoral.name]: Yup.string()
      .trim()
      .required(`${graduatedUniversityInstituteDoctoral.requiredErrorMsg}`),
    [countryDoctoral.name]: Yup.string()
      .trim()
      .required(`${countryDoctoral.requiredErrorMsg}`),
    [dateGraduationDoctoral.name]: Yup.date()
      .nullable()
      .required(`${dateGraduationDoctoral.requiredErrorMsg}`)
      .transform((v) => (v instanceof Date && !isNaN(v) ? v : null))
  }),

  //page4
  Yup.object().shape({
    [workingExperienceList.name]: Yup.array().of(
      Yup.object().shape({
        // [workingExperienceList.subMenu[0].position.name]: Yup.string().required(
        //   `${workingExperienceList.subMenu[0].position.requiredErrorMsg}`
        // ),
        // [workingExperienceList.subMenu[0].companyOrganization.name]:
        //   Yup.string().required(
        //     `${workingExperienceList.subMenu[0].companyOrganization.requiredErrorMsg}`
        //   ),
        // [workingExperienceList.subMenu[0].country.name]: Yup.string().required(
        //   `${workingExperienceList.subMenu[0].country.requiredErrorMsg}`
        // ),
        [workingExperienceList.subMenu[0].started.name]: Yup.date()
          .nullable()
          // .required(
          //   `${workingExperienceList.subMenu[0].started.requiredErrorMsg}`
          // )
          .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
        // [workingExperienceList.subMenu[0].ended.name]: Yup.date().when(
        //   workingExperienceList.subMenu[0].stillInRole.name,
        //   {
        //     is: (stillRole) => stillRole === false,
        //     then: Yup.date()
        //       .nullable()
        //       // .required(
        //       //   `${workingExperienceList.subMenu[0].ended.requiredErrorMsg}`
        //       // )
        //       .transform((v) => (v instanceof Date && !isNaN(v) ? v : null))
        //   }
        // ),
        [workingExperienceList.subMenu[0].stillInRole.name]: Yup.boolean()
      })
    ),
    // [publication.name]: Yup.string().required(
    //   `${publication.requiredErrorMsg}`
    // ),
    // [awards.name]: Yup.string().required(`${awards.requiredErrorMsg}`),
    [cvOrResume.name]: Yup.object()
      .shape({
        [cvOrResume.file]: Yup.mixed()
      })
      .nullable()
      //.required(`${cvOrResume.requiredErrorMsg}`)
  })
];
